import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "sourceType", "sourceId"];

  connect() {
    this.allOptions = Array.from(this.selectTarget.options);
  }

  change() {
    const value = this.selectTarget.value;

    if (!value) {
      this.sourceIdTarget.value = "";
      this.sourceTypeTarget.value = "";
      return;
    }

    const [type, id] = value.split(":");

    this.sourceIdTarget.value = id;
    this.sourceTypeTarget.value = type;
  }
}
